<template>
  <nav class="top">
    <div class="wrap nav-inner">
      <router-link :to="localePath('/')" class="brand" aria-label="Orchestratio">
        <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 714 90" aria-hidden="true">
          <path d="M1.22,45.73C1.22,21.37,20,2.7,44.36,2.7s43.15,18.67,43.15,43.03-18.79,43.03-43.15,43.03S1.22,70.09,1.22,45.73ZM72.36,45.73c0-16.48-12-28.6-28-28.6s-28,12.12-28,28.6,12,28.6,28,28.6,28-12,28-28.6Z"/>
          <path d="M97.33,27.31h13.94v8.24c3.39-5.21,8.97-8.24,17.33-8.24h4.12v14.67h-5.94c-10.54,0-14.91,5.45-14.91,14.79v30.79h-14.54V27.31Z"/>
          <path d="M136.11,57.48c0-17.7,13.7-31.39,31.51-31.39,15.76,0,28.24,10.91,30.66,25.69h-14.91c-2.06-6.91-7.88-12-15.76-12-9.7,0-16.97,7.64-16.97,17.7s7.27,17.57,16.97,17.57c7.88,0,13.7-5.09,15.76-12h14.91c-2.3,14.67-14.91,25.69-30.66,25.69-17.82,0-31.51-13.7-31.51-31.27Z"/>
          <path d="M207.01,3.91h14.54v29.21c3.76-4.48,9.45-7.03,16.6-7.03,15.03,0,25.45,10.67,25.45,27.27v34.18h-14.54v-32.84c0-9.33-4.97-14.79-13.33-14.79s-14.18,5.7-14.18,14.79v32.84h-14.54V3.91Z"/>
          <path d="M271.73,57.36c0-17.57,13.33-31.27,30.79-31.27s30.3,13.21,30.3,31.15c0,1.45-.12,3.15-.36,4.61h-46.3c1.58,9.33,8,14.42,16.85,14.42,7.03,0,12.48-3.64,15.03-8.85h14.91c-4.61,13.21-16.48,21.33-29.94,21.33-17.82,0-31.27-13.7-31.27-31.39ZM318.03,51.55c-1.21-7.64-7.15-12.97-15.76-12.97-7.88,0-13.94,4.73-15.88,12.97h31.63Z"/>
          <path d="M338.75,68.51h14.54c.85,5.33,5.21,8.73,11.76,8.73s10.3-2.42,10.3-6.79-3.15-5.94-10.91-7.27l-5.82-1.09c-13.21-2.3-18.54-7.64-18.54-17.57,0-11.27,10.3-18.42,24-18.42,14.42,0,24.73,8.61,25.09,19.88h-14.54c-.61-4.24-4.48-8.36-10.91-8.36-5.45,0-9.33,2.42-9.33,6.79s3.27,5.94,11.03,7.27l5.82,1.09c13.21,2.3,18.67,7.88,18.67,17.57,0,11.39-10.3,18.42-24.85,18.42-15.51,0-25.69-8.73-26.3-20.24Z"/>
          <path d="M403.35,68.39v-27.75h-9.7v-13.33h6.67c1.82,0,3.03-1.21,3.03-3.51v-13.82h14.54v17.33h15.63v13.33h-15.63v26.3c0,4.73,2.3,7.03,7.64,7.03h8v13.57h-9.33c-14.06,0-20.85-6.06-20.85-19.15Z"/>
          <path d="M442.38,27.31h13.94v8.24c3.39-5.21,8.97-8.24,17.33-8.24h4.12v14.67h-5.94c-10.54,0-14.91,5.45-14.91,14.79v30.79h-14.54V27.31Z"/>
          <path d="M481.16,57.48c0-17.7,12.97-31.39,30.18-31.39,8.24,0,15.15,3.27,19.51,8.85v-7.64h13.82v60.24h-13.82v-7.51c-4.24,5.45-11.27,8.73-19.51,8.73-17.21,0-30.18-13.7-30.18-31.27ZM530.25,57.48c0-10.3-7.27-17.7-17.21-17.7s-17.33,7.39-17.33,17.7,7.27,17.57,17.33,17.57,17.21-7.39,17.21-17.57Z"/>
          <path d="M561.88,68.39v-27.75h-9.7v-13.33h6.67c1.82,0,3.03-1.21,3.03-3.51v-13.82h14.54v17.33h16.85v13.33h-16.85v26.3c0,4.73,2.3,7.03,7.64,7.03h6.3v13.57h-7.64c-14.06,0-20.85-6.06-20.85-19.15Z"/>
          <path d="M674.6,75.06c-7.03,8.24-15.27,13.45-25.45,13.45-9.45,0-15.15-4.48-17.21-9.21-5.94,6.42-12.36,9.21-19.76,9.21-6.91,0-13.33-3.27-14.18-11.76-.61-6.67,2.06-18.91,8.48-33.57l4.73-10.79c2.06-4.85,6.06-7.03,10.67-5.33,4.48,1.7,4.85,5.7,2.67,10.67l-3.51,7.88c-7.39,16.97-8.61,24-8.48,26.79.12,1.82,1.33,2.67,3.51,2.67,3.27,0,7.15-3.03,11.88-11.39,3.39-5.94,6.79-12.61,9.7-17.7,5.09-8.85,14.06-19.27,27.88-19.27,11.76,0,18.3,7.27,19.27,16.85.61,6.06-1.09,12.36-3.51,17.82,6.3-.85,10.79-4.48,18.67-14.06,3.27-4.12,7.15-4.85,10.67-1.82,2.54,2.18,2.54,6.3,0,10.3-6.54,10.3-20.36,20.24-36,19.27ZM620.54,10.82c.24-5.45,4.48-9.58,9.94-9.58s9.58,4.12,9.33,9.58c-.24,5.58-4.48,9.7-10.06,9.7s-9.45-4.12-9.21-9.7ZM660.29,70.94c-8.12-1.94-12.73-7.15-13.82-12.48-1.94,4-3.15,8.24-2.79,11.64.36,3.27,2.42,5.58,7.15,5.58,3.39,0,6.54-1.7,9.45-4.73ZM670.47,45.24c-.24-3.03-2.06-5.58-5.58-5.58-4.12,0-7.63,2.67-9.09,5.94-2.18,4.73,4.73,12.24,11.03,13.21,1.94-3.39,4-9.45,3.64-13.57Z"/>
        </svg>
      </router-link>
      <div class="nav-links desktop">
        <div class="lang-switch">
          <button
            class="lang-btn"
            :class="{ 'lang-btn--active': isEnglish }"
            :aria-pressed="isEnglish ? 'true' : 'false'"
            @click="switchLocale('en')"
          >EN</button>
          <button
            class="lang-btn"
            :class="{ 'lang-btn--active': isDutch }"
            :aria-pressed="isDutch ? 'true' : 'false'"
            @click="switchLocale('nl')"
          >NL</button>
        </div>
        <button
          class="theme-toggle"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme"
        >
          <svg v-if="!isDark" class="icon-moon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
          <svg v-else class="icon-sun" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2"></path><path d="M12 20v2"></path><path d="m4.93 4.93 1.41 1.41"></path><path d="m17.66 17.66 1.41 1.41"></path><path d="M2 12h2"></path><path d="M20 12h2"></path><path d="m6.34 17.66-1.41 1.41"></path><path d="m19.07 4.93-1.41 1.41"></path></svg>
        </button>
        <router-link :to="localePath('/contact')" class="nav-cta">{{ t('nav.cta') }}</router-link>
      </div>
      <button class="hamburger" type="button" aria-label="Menu" @click="menuOpen = !menuOpen">
        <span :class="{ open: menuOpen }"></span>
      </button>
    </div>
    <div v-if="menuOpen" class="nav-mobile" @click="menuOpen = false">
      <router-link :to="localePath('/contact')" class="nav-mobile-link">{{ t('nav.cta') }}</router-link>
      <div class="nav-mobile-controls" @click.stop>
        <div class="lang-switch">
          <button
            class="lang-btn"
            :class="{ 'lang-btn--active': isEnglish }"
            @click="switchLocale('en'); menuOpen = false"
          >EN</button>
          <button
            class="lang-btn"
            :class="{ 'lang-btn--active': isDutch }"
            @click="switchLocale('nl'); menuOpen = false"
          >NL</button>
        </div>
        <button
          class="theme-toggle"
          :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="toggleTheme"
        >
          <svg v-if="!isDark" class="icon-moon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
          <svg v-else class="icon-sun" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2"></path><path d="M12 20v2"></path><path d="m4.93 4.93 1.41 1.41"></path><path d="m17.66 17.66 1.41 1.41"></path><path d="M2 12h2"></path><path d="M20 12h2"></path><path d="m6.34 17.66-1.41 1.41"></path><path d="m19.07 4.93-1.41 1.41"></path></svg>
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
import { useLocale } from '@/composables/useLocale'
import { useTheme } from '@/composables/useTheme'
import { useRouter } from 'vue-router'

const { t, isEnglish, isDutch, setLocale, localePath } = useLocale()
const { isDark, toggleTheme } = useTheme()
const router = useRouter()
const menuOpen = ref(false)

function switchLocale(lang) {
  const currentPath = router.currentRoute.value.path
  const basePath = currentPath.replace(/^\/nl/, '') || '/'
  setLocale(lang)
  const newPath = lang === 'nl' ? (basePath === '/' ? '/nl' : `/nl${basePath}`) : basePath
  router.push(newPath)
}
</script>

<style>
nav.top { position: sticky; top: 0; z-index: 100; padding: 32px 0; border-bottom: 1px solid var(--line-on-blue); background: var(--bg); }
.nav-inner {
  display: flex; align-items: center; justify-content: space-between; gap: 24px;
}
.brand {
  display: inline-flex; align-items: center;
  color: var(--ink-on-blue);
}
.brand svg.logo {
  height: 30px;
  width: auto;
  display: block;
  fill: currentColor;
}
.brand:hover { color: var(--cream); }
.nav-links {
  display: flex; align-items: center; gap: 10px;
  font-size: 15px;
  font-weight: 600;
  color: var(--ink-on-blue);
}
.nav-links a {
  transition: opacity .15s ease;
  opacity: 0.85;
}
.nav-links a:hover { opacity: 1; }
.nav-cta {
  display: inline-flex; align-items: center;
  height: 44px;
  padding: 0 26px;
  background: var(--cta-bg);
  border: 1px solid var(--cta-bg);
  border-radius: 999px;
  font-size: 15px;
  font-weight: 600;
  color: var(--cta-ink);
  box-sizing: border-box;
  transition: transform .15s ease, box-shadow .15s ease, background .2s ease, color .2s ease;
}
.nav-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
  color: var(--cta-ink);
}
.lang-switch {
  display: inline-flex;
  align-items: center;
  height: 44px;
  border-radius: 9999px;
  border: 1px solid var(--line-on-blue-strong);
  background: rgba(255, 255, 255, 0.08);
  padding: 4px;
  box-sizing: border-box;
}
.lang-btn {
  height: 34px;
  padding: 0 14px;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  background: transparent;
  border: none;
  color: var(--ink-on-blue-muted);
  cursor: pointer;
  transition: background .2s ease, color .2s ease;
  font-family: inherit;
  letter-spacing: 0.02em;
  display: inline-flex;
  align-items: center;
}
.lang-btn:not(.lang-btn--active):hover { color: var(--ink-on-blue); }
.lang-btn--active {
  background: var(--ink-on-blue);
  color: var(--blue-darker);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}
[data-theme="dark"] .lang-btn--active {
  color: var(--blue-darker);
}
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  border: 1px solid var(--line-on-blue-strong);
  background: transparent;
  color: var(--ink-on-blue-muted);
  cursor: pointer;
  transition: color .2s ease, border-color .2s ease, transform .2s ease;
  padding: 0;
  box-sizing: border-box;
}
.theme-toggle:hover {
  color: var(--ink-on-blue);
  border-color: var(--ink-on-blue);
  transform: rotate(-12deg);
}
.theme-toggle svg { width: 18px; height: 18px; display: block; }

/* Hamburger */
.hamburger {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  width: 44px;
  height: 44px;
  position: relative;
}
.hamburger span,
.hamburger span::before,
.hamburger span::after {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--ink-on-blue);
  border-radius: 2px;
  position: absolute;
  left: 11px;
  transition: transform 0.25s, opacity 0.2s;
}
.hamburger span { top: 21px; }
.hamburger span::before { content: ''; top: -7px; }
.hamburger span::after { content: ''; top: 7px; }
.hamburger span.open { background: transparent; }
.hamburger span.open::before { top: 0; transform: rotate(45deg); }
.hamburger span.open::after { top: 0; transform: rotate(-45deg); }

/* Mobile menu */
.nav-mobile {
  display: none;
  flex-direction: column;
  padding: 8px 0 0;
}
.nav-mobile-link {
  display: block;
  padding: 14px var(--pad);
  color: var(--ink-on-blue);
  font-weight: 600;
  font-size: 16px;
  transition: background .15s ease;
}
.nav-mobile-link:hover { background: rgba(255, 255, 255, 0.08); }
.nav-mobile-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px var(--pad) 0;
}

@media (max-width: 720px) {
  .nav-links.desktop { display: none; }
  .hamburger { display: block; }
  .nav-mobile { display: flex; }
  .nav-mobile-controls .lang-switch { height: 36px; }
  .nav-mobile-controls .lang-btn { height: 28px; padding: 0 10px; font-size: 12px; }
  .nav-mobile-controls .theme-toggle { width: 36px; height: 36px; }
  .nav-mobile-controls .theme-toggle svg { width: 15px; height: 15px; }
}
</style>
